import { useTranslation } from 'react-i18next'
import { BirthInputError } from '../../helpers/birthDateTime'

export type BirthInputScope = 'date' | 'time'

// Labels, help and errors come from the same dictionary in PT/EN/ES/FR. The scope
// keeps the date and the time messages specific without duplicating the lookup.
export function useBirthInputMessages(scope: BirthInputScope, language?: string) {
  const { t, i18n } = useTranslation()
  const locale = language ?? i18n?.resolvedLanguage ?? i18n?.language ?? 'en'
  const text = (key: string) => String(t(`birthInput_${key}`, { lng: locale }))
  return {
    text,
    monthFirst: locale.toLowerCase().split(/[-_]/)[0] === 'en',
    errorText: (error?: BirthInputError) => (error ? text(`${scope}_error_${error}`) : undefined),
  }
}
